
export const SET_WEBSOCKET = "SET_WEBSOCKET"